import Settings from "#/modules/settings/Settings";

export default Settings;
